import React, { useEffect, useRef, useState } from 'react';
import { useTableOfContext } from '@/contexts/TableOfContentContext';
import { cn } from '@/lib/utils';

interface TocWrapperProps {
  name: string;
  displayName: string;
  level?: number;
  className?: string;
  children: React.ReactNode;
  error?: string;
}

export const TocWrapper = ({
  name,
  displayName,
  level = 1,
  className,
  children,
  error,
}: TocWrapperProps) => {
  const id = name.toLowerCase().replace(/\s+/g, '-');
  const { addItem, removeItem } = useTableOfContext();
  const [errorContent, setErrorContent] = useState<string | undefined>();
  const wrapperRef = useRef<HTMLDivElement>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const errorElement = wrapperRef.current?.querySelector(
      '[aria-label="error"]',
    );
    setErrorContent(errorElement?.innerHTML);
  });

  useEffect(() => {
    const item = { id, name, displayName, level, error: error || errorContent };
    addItem(item);
    return () => removeItem(id);
  }, [id, name, displayName, level, addItem, removeItem, error, errorContent]);

  return (
    <div id={id} ref={wrapperRef} className={cn('scroll-mt-16', className)}>
      {children}
    </div>
  );
};
